import { render, staticRenderFns } from "./BirthDateField.vue?vue&type=template&id=63247369"
import script from "./BirthDateField.vue?vue&type=script&lang=js"
export * from "./BirthDateField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports